import React from 'react';

interface SpinnerProps {
  size?: number;
  color?: string;
  center?: boolean;
  className?: string;
}

const Spinner: React.FC<SpinnerProps> = ({size = 32, color = '#1A71DB', center = false, className = ''}) => (
  <div className={center ? `flex items-center justify-center w-full h-full ${className}` : className}>
    <svg
      width={size}
      height={size}
      viewBox="0 0 50 50"
      className="animate-spin"
      style={{display: 'inline-block'}}
    >
      <circle
        cx="25"
        cy="25"
        r="20"
        fill="none"
        stroke={color}
        strokeWidth="5"
        strokeDasharray="31.4 31.4"
        strokeLinecap="round"
      />
    </svg>
  </div>
);

export default Spinner;
